import React, { useEffect, useState } from 'react';

const floatToDigits = (value) => {
    if (value === '' || value === null || value === undefined) return '';
    const n = parseFloat(value);
    if (!Number.isFinite(n) || n === 0) return '';
    return Math.round(n * 100).toString();
};

const digitsToFloat = (digits) => {
    if (!digits) return '';
    return parseFloat((parseInt(digits, 10) / 100).toFixed(2));
};

const formatATM = (digits) => {
    if (!digits) return '';
    const padded = digits.padStart(3, '0');
    const intRaw = padded.slice(0, -2).replace(/^0+/, '') || '0';
    const dec = padded.slice(-2);
    const int = intRaw.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `R$ ${int},${dec}`;
};

const useATMInput = ({ value, onFocus, onBlur, emitChange }) => {
    const [digits, setDigits] = useState(() => floatToDigits(value));
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        if (!focused) setDigits(floatToDigits(value));
    }, [value, focused]);

    const handleFocus = (e) => { setFocused(true); onFocus?.(e); };
    const handleBlur  = (e) => { setFocused(false); onBlur?.(e); };

    const handleKeyDown = (e) => {
        const allowed = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!/^\d$/.test(e.key) && !allowed.includes(e.key)) e.preventDefault();
    };

    const handleChange = (e) => {
        const raw = e.target.value.replace(/\D/g, '').replace(/^0+/, '').slice(0, 12);
        setDigits(raw);
        emitChange(digitsToFloat(raw));
    };

    return {
        displayValue: formatATM(digits),
        handleFocus,
        handleBlur,
        handleKeyDown,
        handleChange,
    };
};

export function PriceMask({ value, onChange, name, ...rest }) {
    const { displayValue, handleFocus, handleBlur, handleKeyDown, handleChange } = useATMInput({
        value,
        onFocus: rest.onFocus,
        onBlur: rest.onBlur,
        emitChange: (v) => onChange(name, v),
    });

    return (
        <input
            {...rest}
            type="text"
            inputMode="numeric"
            name={name}
            value={displayValue}
            placeholder="R$ 0,00"
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
        />
    );
}

export const PriceInputMasked = React.forwardRef(function PriceInputMasked(props, ref) {
    const { onChange, name, value, onFocus, onBlur, ...rest } = props;
    const { displayValue, handleFocus, handleBlur, handleKeyDown, handleChange } = useATMInput({
        value,
        onFocus,
        onBlur,
        emitChange: (v) => onChange({ target: { name, value: v } }),
    });

    return (
        <input
            {...rest}
            ref={ref}
            type="text"
            inputMode="numeric"
            name={name}
            value={displayValue}
            placeholder="R$ 0,00"
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
        />
    );
});
